module.exports = __webpack_public_path__ + "img/40f052a89b2538e16c8d2c0a4b87d40a.bfc1a6ab.png";